import { RootState } from './RootState';

export type { RootState };

export enum E_USER_ROLE {
  CLIENT = 'client',
  ADMIN = 'admin',
  COMM = 'comm',
  DISTRIB = 'distrib',
  INTEGRATOR = 'integrator',
  INTERNE = 'interne',
  RESTRICTED_ACCESS = 'restricted_access',
}

export enum MEDIA_TYPES {
  PICTURE = 'PICTURE',
  USER_MANUAL = 'USER_MANUAL',
  OTHER = 'OTHER',
  USECASE = 'USECASE',
  SPEC_SHEET = 'SPEC_SHEET',
  LEAFLET = 'LEAFLET',
  VIDEO = 'VIDEO',
}
